import React from 'react';
interface StoreLocatorProps {
  storeLocatorType: string;
  title: string;
}

const StoreLocatorTitle: React.FC<StoreLocatorProps> = ({ storeLocatorType, title }) => (
  <p className={`store-locator-pdp-title body semibold ${storeLocatorType === 'bopis' ? 'bopis' : ''}`}>
    <span className="alo-location-pin-icon"></span>
    {title}
  </p>
);

export default StoreLocatorTitle;
